import { HttpClient } from '@angular/common/http';
import { ApplicationRef, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay, Subject } from 'rxjs';
import * as forge from 'node-forge';
import { URLS } from 'src/app/app-url.constant';
import { MessageService } from '../message.service';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { monthsName } from 'src/app/components/shared/commonData';
import { CurrencyMapData } from 'src/app/components/shared/commonData';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  cityMasterListData!: any;
  stateMasterListData!: any;
  countryMasterListData!: any;
  public _logoImgPath = new BehaviorSubject(localStorage.getItem('logoImg'));

  isStandardScreenModelOpen!: boolean;
  accessTokenForEmail!: string;

  private currentCurrencySubject = new BehaviorSubject<string>('INR');
  currentCurrency$ = this.currentCurrencySubject.asObservable();

  private countryCache$!: Observable<any[]>;
  private countryStateCityCache$!: Observable<any[]>;
  private genderCache$!: Observable<any[]>;

  constructor(
    private http: HttpClient,
    private msgSvc: MessageService,
    private spinner: NgxSpinnerService,
    private _monthsName: monthsName
  ) {}

  public userLoggedIn = new Subject();

  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAskgPKBcNpz71mi4NSYa5
  mazJrO0WZim7T2yy7qPxk2NqQE7OmWWakLJcaeUYnI0kO3yC57vck66RPCjKxWuW
  SGZ7dHXe0bWb5IXjcT4mNdnUIalR+lV8czsoH/wDUvkQdG1SJ+IxzW64WvoaCRZ+
  /4wBF2cSUh9oLwGEXiodUJ9oJXFZVPKGCEjPcBI0vC2ADBRmVQ1sKsZg8zbHN+gu
  U9rPLFzN4YNrCnEsSezVw/W1FKVS8J/Xx4HSSg7AyVwniz8eHi0e3a8VzFg+H09I
  5wK+w39sjDYfAdnJUkr6PjtSbN4/Sg/NMkKB2Ngn8oj7LCfe/7RNqIdiS+dQuSFg
  eQIDAQAB
  -----END PUBLIC KEY-----`;

  public userMenu: any = JSON.parse(localStorage.getItem('validRoutes')!);
  public static superAdminMenu: any[] = [
    {
      name: 'Organization Setup',
      icon: '',
      routerLink: '/setup',
      userRole: ['SuperAdmin', 'Admin'],
      isChild: ['office/create', 'office/edit'],
      isVisible: true,
    },
    {
      name: 'User Management',
      icon: '',
      routerLink: '/user-management',
      userRole: ['SuperAdmin', 'Admin'],
      isVisible: true,
    },
    {
      name: 'Reminder Settings',
      icon: '',
      routerLink: '404',
      userRole: ['SuperAdmin', 'Admin'],
      // isVisible: true,
      isVisible: false,
    },
    {
      name: 'Access Management',
      icon: '',
      routerLink: '/access-management',
      userRole: ['SuperAdmin', 'Admin'],
      isVisible: true,
    },
    {
      name: 'Policies',
      icon: '',
      routerLink: '/policy-management',
      userRole: ['SuperAdmin', 'Admin'],
      isVisible: true,
    },
    {
      name: 'System Configuration',
      icon: '',
      routerLink: '/admin-configuration',
      userRole: ['Admin'],
      isVisible: true,
    },
    {
      name: 'Email Requests',
      icon: '',
      routerLink: '/email-requests',
      userRole: ['Admin'],
      isVisible: true,
    },
  ];
  appVersionCheck() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.GetAngularAppVersions}`
    );
  }

  userLogin(formData: any) {
    const requestBody = {
      username: formData.username,
      // password: formData.password,
      password: this.encryptData(formData.password.trim()),
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.userLogin}`,
      requestBody
    );
  }

  getUserAccessDetails(authToken: any) {
    const header = {
      Authorization: `Bearer ${authToken}`,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.getUserAccessDetails}`,
      { headers: header }
    );
  }

  loginUserWithAccessKey(accessKey: string) {
    const requestBody = {
      accesskey: accessKey,
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.userLoginPlatform}`,
      requestBody
    );
  }

  logout() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.logout}`
    );
  }

  getDomain() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetDomain}`
    );
  }

  changePassword(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.changePassword}`,
      requestBody
    );
  }
  sendOTP(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.SendOTP}`,
      requestBody
    );
  }
  VerifyOTP(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.ValidateOtp}`,
      requestBody
    );
  }
  GenerateRefreshToken() {
    var token: any = JSON.parse(localStorage.getItem('userData')!);
    const requestBody = {
      email: token.username,
      refreshToken: token.refreshToken,
      accessToken: token.accessToken,
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.refreshToken}`,
      requestBody
    );
  }

  searchAddress(
    city: string,
    state: string,
    country: string,
    postalCode: string
  ) {
    let paramData: any = {};
    if (city) paramData['city'] = city;
    if (state) paramData['state'] = state;
    if (country) paramData['country'] = country;
    if (postalCode) paramData['postalcode'] = postalCode;
    paramData['format'] = 'jsonv2';
    paramData['addressdetails'] = 1;

    return this.http.get(`${URLS.baseAddressUrl}${URLS.addressUrl.endpoint}`, {
      params: paramData,
    });
  }

  addCityInList(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.AddCityMaster}`,
      requestBody
    );
  }

  getCountryList(): Observable<any[]> {
    if (this.countryCache$) {
      return this.countryCache$;
    }

    this.countryCache$ = this.http
      .get<
        any[]
      >(`${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllCountryMaster}`)
      .pipe(
        map((res: any) => res || []),
        shareReplay(1) // cache the latest value in memory
      );

    return this.countryCache$;
  }

  // getCountryList() {
  //   return this.http.get(
  //     `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllCountryMaster}`
  //   );
  // }

  getStateList(countryId: any) {
    let param = {
      CountryId: countryId,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetStateByCountryId}`,
      { params: param }
    );
  }

  getAllCountryStateList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllStateMaster}`
    );
  }

  getCityList(stateId: any) {
    let param = {
      StateId: stateId,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetCityByStateId}`,
      { params: param }
    );
  }

  // getAllCountryStateCityList() {
  //   return this.http.get(
  //     `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllCityMaster}`
  //   );
  // }

  getAllCountryStateCityList(): Observable<any[]> {
    // If cache already exists -> return it
    if (this.countryStateCityCache$) {
      return this.countryStateCityCache$;
    }

    // Else call the API and cache the result
    this.countryStateCityCache$ = this.http
      .get<
        any[]
      >(`${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllCityMaster}`)
      .pipe(
        map((res: any) => res || []),
        shareReplay(1) // Cache result
      );

    return this.countryStateCityCache$;
  }

  getReqLoginUserName() {
    if (localStorage.getItem('userData'))
      return JSON.parse(localStorage.getItem('userData')!).username;
  }

  getRole() {
    if (localStorage.getItem('userData'))
      return JSON.parse(localStorage.getItem('userData')!).roleName;
  }

  isUserLoggedIn(): boolean {
    ///return true if we have token in local storage
    if (localStorage.getItem('authToken')) return true;
    else return false;
  }

  // Method to encrypt Data
  encryptData(data: any) {
    var rsa: any = forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(data));
  }

  // method to decrypt data
  decryptData(data: any) {
    var rsa: any = forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(data));
  }

  // indiaStateColor(state: string): string {
  //   // Define colors for states, you can customize this
  //   const colors: { [key: string]: string } = {
  //     'Andaman and Nicobar': '#ff7f50',
  //     'Andhra Pradesh': '#ff6434',
  //     'Arunachal Pradesh': '#cd6667',
  //     Assam: '#6d9869',
  //     Bihar: '#6997ca',
  //     Chandigarh: '#6799cd',
  //     Chhattisgarh: '#ffcc01',
  //     'Dadra and Nagar Haveli': '#da70d6',
  //     'Daman and Diu': '#cc6667',
  //     Delhi: '#cc6667',
  //     Goa: '#da70d6',
  //     Gujarat: '#cc6667',
  //     Haryana: '#6a986b',
  //     'Himachal Pradesh': '#f76a2f',
  //     'Jammu and Kashmir': '#ffcc01',
  //     Jharkhand: '#015e89',
  //     Karnataka: '#679966',
  //     Kerala: '#d06467',
  //     Lakshadweep: '#015e89',
  //     'Madhya Pradesh': '#66669a',
  //     Maharashtra: '#ffcc9a',
  //     Manipur: '#ce6764',
  //     Meghalaya: '#015e89',
  //     Mizoram: '#feca32',
  //     Nagaland: '#6799cd',
  //     Orissa: '#cc6667',
  //     Puducherry: '#015e89',
  //     Punjab: '#6899cb',
  //     Rajasthan: '#ffcc01',
  //     Sikkim: '#ce6764',
  //     'Tamil Nadu': '#ffcc01',
  //     Tripura: '#66669a',
  //     'Uttar Pradesh': '#cc6667',
  //     Uttaranchal: '#fccd00',
  //     'West Bengal': '#ffca03',
  //   };

  //   return colors[state] || '#ffffff';
  // }

  getUserAccessModule() {
    if (localStorage.getItem('userAccessModule'))
      return JSON.parse(localStorage.getItem('userAccessModule')!);
  }

  getUserAccessSubmodules() {
    const subModuleDetails: any = [];
    const userAccessModule = this.getUserAccessModule();
    userAccessModule?.forEach((modules: any) => {
      subModuleDetails?.push(...modules?.getUserAccessSubModuleDetails);
    });

    return subModuleDetails;
  }

  GetConfigurationValue(requestBodyData: any) {
    let requestBody: any = this.generateRequestBody(requestBodyData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetConfigurationValue}`,
      requestBody
    );
  }

  generateRequestBody(data: any) {
    return {
      requestUserLoginName:
        JSON.parse(localStorage.getItem('userData')!)?.username || '',
      requestId: 'string',
      data: data,
      message: 'string',
    };
  }

  GetReportingYearsAsync(data: any) {
    let requestBody = this.generateRequestBody(data);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetReportingYearsAsync}`,
      requestBody
    );
  }

  getAllOfficeList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.CorporateOfficeMaster.endpoint}${URLS.CorporateOfficeMaster.methods.GetAllOfficeDetail}`
    );
  }

  GetAllOfficeMasterWithUserAccess(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllOfficeMasterWithUserAccess}`,
      requestBody
    );
  }

  getAllUnitMaster() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllUnitMaster}`
    );
  }
  getAllCurrencyMaster() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllCurrencyMaster}`
    );
  }

  getCurrentCurrency() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetCurrentCurrency}`
    );
  }

  GetAllSiteOffices(data: any) {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.GetAllSiteOfficeMaster}`
    );
  }
  getRegionalOfficeList(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.RegionalOfficeMaster.endpoint}${URLS.RegionalOfficeMaster.methods.GetAllRegionalOfficeMasterByUserId}`,
      requestBody
    );
  }

  getRegionalOfficeDataById(id: any) {
    let param = {
      Id: id,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.RegionalOfficeMaster.endpoint}${URLS.RegionalOfficeMaster.methods.GetRegionalOfficeMasterById}`,
      { params: param }
    );
  }

  getSiteOfficeList(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.GetAllSiteOfficeMasterByRegionalOfficeId}`,
      requestBody
    );
  }

  getSiteOfficeDataById(id: any) {
    let param = {
      Id: id,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.SiteOfficeMaster.endpoint}${URLS.SiteOfficeMaster.methods.GetSiteOfficeMasterById}`,
      { params: param }
    );
  }

  getCorporateOfficeDataById(id: any) {
    let param = {
      Id: id,
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.CorporateOfficeMaster.endpoint}${URLS.CorporateOfficeMaster.methods.GetCorporateOfficeMasterById}`,
      { params: param }
    );
  }

  GetAllMaritalStatusList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllEmployeeMaritalStatusTypeMaster}`
    );
  }

  async loadThemeCSS(theme: string): Promise<void> {
    const defaulCss =
      ":root {--sidebar-bg-color:#043033;--sidebar-color:#fff;--mainNavBar-bg-color:linear-gradient(to right, #01587c 0%, #01444a 100%);--mainNavBar-color:#fff;--tableHeader-bg-color: #ecf3f8;--tableHeader-color: #015e89;--tableHeader2-color: #8e8e8e;--approveStatusTextColor:#238636;--approveStatusBackgroundColor:#238636;--rejectStatusTextColor:#cd0018;--rejectStatusBackgroundColor:#cd0018;--draftStatusTextColor:#ffa500;--draftStatusBackgroundColor:#ffa500;--primaryTextColor:#015e89;--primaryBackgroundColor:#015e89;--primaryButton-bg-color:#015e89;--primaryButton-color:#fff;--secondaryButton-bg-color:#fff;--secondaryButton-color:#015e89;--font-family:'Montserrat', sans-serif;--screen-background:#fff;}";

    try {
      const response = await this.http
        .get<any>(
          `${URLS.baseApiHostUrl}${URLS.login.endpoint}${URLS.login.methods.GetBrandingConfigurationValue}`
        )
        .toPromise();

      if (response) {
        const style = document.createElement('style');
        style.innerHTML = response?.data?.value;
        document.head.appendChild(style);
      } else {
        const style = document.createElement('style');
        style.innerHTML = defaulCss;
        document.head.appendChild(style);
      }
    } catch (error) {
      console.error('Error loading theme CSS:', error);
      const style = document.createElement('style');
      style.innerHTML = defaulCss;
      document.head.appendChild(style);
    }
  }

  loadChatBot() {
    if (!this.isUserLoggedIn) return;

    var scriptCode = `import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';

      createChat({
        webhookUrl:
          'https://yjit72.app.n8n.cloud/webhook/d0db23a8-e8a8-4044-9493-f52f65bdf413/chat',
          initialMessages: [
          'Hi there! 👋',
          'My name is ZOEI AI Agent. How can I assist you today?'
          ],
      });`;
    const script = document.createElement('script');
    script.type = 'module';
    script.text = scriptCode;
    document.head.appendChild(script);
  }

  GetAllGender(): Observable<any[]> {
    // If cache already exists -> return it
    if (this.genderCache$) {
      return this.genderCache$;
    }

    // Else call the API and cache the result
    this.genderCache$ = this.http
      .get<
        any[]
      >(`${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllGender}`)
      .pipe(
        map((res: any) => res || []),
        shareReplay(1) // Cache result
      );

    return this.genderCache$;
  }

  getFormattedCurrentDateAndTime() {
    const now = new Date();
    const formattedDate = now.toLocaleDateString('en-GB').replace(/\//g, '/'); // e.g., 05/05/25
    const formattedTime = now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }); // e.g., 11:24 AM

    return `${formattedDate} ${formattedTime}`;
  }

  // this function flatten the tree list array into simple array
  flattenLocationTreeArrayToMap(nodes: any[]): Map<string, any> {
    const map = new Map<string, any>();

    for (const node of nodes) {
      this.traverse(node, map);
    }

    return map;
  }

  // traversing the children
  traverse(node: any, map: any) {
    if (!node || !node.key) return;
    map.set(node.key, node);
    if (Array.isArray(node.children)) {
      for (const child of node.children) {
        this.traverse(child, map);
      }
    }
  }

  // scroll to the first element
  scrollToContent(element: HTMLElement) {
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
    }
  }

  DownloadDocumentDataAsync(filePath: string) {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.DownloadDocument}?path=${encodeURIComponent(filePath)}`,
      { responseType: 'blob' }
    );
  }

  openDocument(fileUrl: string, fName?: string): void {
    if (!fileUrl) {
      return;
    }
    // this.spinner.show();
    this.DownloadDocumentDataAsync(fileUrl).subscribe((res: any) => {
      const url = window.URL.createObjectURL(res);
      const anchor = document.createElement('a');
      const fileName = fName
        ? fName
        : fileUrl?.split(/[/\\]/).pop() || 'downloaded-file';
      anchor.href = url;
      anchor.download = fileName;
      anchor.click();
      window.URL.revokeObjectURL(url);
      // this.spinner.hide();
    });
  }

  GetEmployees() {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetEmployees}`,
      {}
    );
  }

  AddBulkEmployesDeatils(data: any) {
    let requestBody = this.generateRequestBody(data);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.AddBulkEmployesDeatils}`,
      requestBody
    );
  }

  getDefaultSlot(slots: any[]) {
    if (!slots || slots.length === 0) return null;

    //  Check localStorage first
    const storedSlotId = localStorage.getItem('reportingSlotYearId');
    if (storedSlotId) {
      const storedSlot = slots.find(s => s.id === Number(storedSlotId));
      if (storedSlot) {
        return storedSlot;
      }
    }

    //  Check current slot
    const currentSlot = slots.find(s => s.isItCurrentSlot === true);
    if (currentSlot) {
      return currentSlot;
    }

    //  Fallback
    return slots[0];
  }

  getDefaultSlotByCurrentYear(slots: any[]) {
    if (!slots || slots.length === 0) return null;

    //  Check localStorage first
    const storedYearId = localStorage.getItem('reportingYearId');
    if (storedYearId) {
      const storedYear = slots.find(s => s.id === Number(storedYearId));
      if (storedYear) {
        return storedYear;
      }
    }

    //  Check current year
    const currentYear = slots.find(s => s.isItCurrentYear === true);
    if (currentYear) {
      return currentYear;
    }

    //  Fallback
    return slots[0];
  }

  /**
   * get the index (0-January, 1- February..) of the month passed to create a new date
   * @param monthName
   * @returns
   */
  getMonthsNumber(monthName: any) {
    const monthList = Object?.keys(this._monthsName?.months)
      .sort((a, b) => +a - +b) // sort by numeric keys to ensure order
      .map(key => this._monthsName?.months[key]); // array of names

    return monthList?.findIndex(
      (name: any) => name.toLowerCase() == monthName.toLowerCase()
    );
  }

  setCurrentCurrency(code: string): void {
    this.currentCurrencySubject.next(code);
  }

  getCurrency(): string {
    return this.currentCurrencySubject.getValue();
  }

  getCurrencySymbol(code?: string): string {
    const currencyCode = code || this.getCurrency();
    return `(in ${CurrencyMapData.currencySymbolMap[currencyCode] || currencyCode})`;
  }

  getCurrencyLabel(code: string = this.getCurrency()): string {
    return `(in ${code})`;
  }

  getCurrencyLabelWithSymbol(): string {
    return `(in ${this.getCurrencySymbol()})`;
  }

  /**
   * removed single array or object from array of objects
   * if any of the field in array is empty or null or 0 or undefined
   *
   * @param array
   * @returns
   */
  filterOutEmptyData(array: any, ignoreKeys: any = []) {
    return array.filter((obj: any) => {
      if (typeof obj !== 'object' || obj === null) return false;

      return Object.entries(obj).some(([key, value]) => {
        if (ignoreKeys?.includes(key)) return false;

        if (typeof value === 'string') {
          return value.trim() !== '';
        }
        return value !== null && value !== 0 && value !== undefined;
      });
    });
  }

  removeLocalStorageData() {
    localStorage.removeItem('userData');
    localStorage.removeItem('authToken');
    localStorage.removeItem('imageUrl');
    localStorage.removeItem('validRoutes');
    localStorage.removeItem('userAccessModule');
  }

  /**
   * show spinner while authenticating tenant
   */
  showSimpleLoader() {
    if (!document.getElementById('authentication-loader')) {
      const loader = document.createElement('div');
      loader.id = 'authentication-loader';
      loader.style.position = 'fixed';
      loader.style.top = '0';
      loader.style.left = '0';
      loader.style.width = '100vw';
      loader.style.height = '100vh';
      loader.style.backgroundColor = '#ffffff';
      loader.style.display = 'flex';
      loader.style.flexDirection = 'column';
      loader.style.justifyContent = 'center';
      loader.style.alignItems = 'center';
      loader.style.zIndex = '9999';

      loader.innerHTML = `
      <div style="border: 6px solid #f3f3f3; border-top: 6px solid #3498db; border-radius: 50%; width: 50px; height: 50px; animation: spin 1s linear infinite;"></div>
      <div style="margin-top: 16px; font-size: 18px; color: #333; text-align: center;">
        Authenticating your access...<br><span style="font-size:14px; color:#666;">Please wait</span>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;

      document.body.appendChild(loader);
    }
  }

  showSimpleLoader2() {
    if (!document.getElementById('authentication-loader')) {
      const loader = document.createElement('div');
      loader.id = 'authentication-loader';
      loader.style.position = 'fixed';
      loader.style.top = '0';
      loader.style.left = '0';
      loader.style.width = '100vw';
      loader.style.height = '100vh';
      loader.style.backgroundColor = 'white';
      loader.style.color = '#333';
      loader.style.fontSize = '24px';
      loader.style.display = 'flex';
      loader.style.justifyContent = 'center';
      loader.style.alignItems = 'center';
      loader.style.zIndex = '9999';
      loader.innerText = 'Authenticating your access, please wait...';
      document.body.appendChild(loader);
    }
  }

  /**
   * hide the loader after authenticating tenant
   */
  hideSimpleLoader() {
    const loader = document.getElementById('authentication-loader');
    if (loader) {
      document.body.removeChild(loader);
    }
  }

  /**
   * fetch the nested data from an array of objects
   *
   * @param data
   * @param dataStructure
   * @returns
   */
  getNestedData(data: any, dataStructure: any) {
    return dataStructure.reduce((acc: any, key: any) => acc?.[key], data);
  }

  GetDataCapturingSlotGroup() {
    let param = {
      OrgnizationID: Number(
        JSON.parse(localStorage.getItem('userData')!).corporateofficeId
      ),
    };
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetDataCapturingSlotGroup}`,
      { params: param }
    );
  }

  // require Number in requestBody
  GetAllUnitByTagId(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllUnitByTagId}`,
      requestBody
    );
  }

  // require array of Number in requestBody
  GetAllUnitByTagsId(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllUnitByTagsId}`,
      requestBody
    );
  }

  GetCsvFromStoredProcedure(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.AI.endpoint}${URLS.AI.methods.GetCsvFromStoredProcedure}`,
      requestBody
    );
  }

  GetCsvFromTotalEmissionCatWise(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.AI.endpoint}${URLS.AI.methods.GetCsvFromTotalEmissionCatWise}`,
      requestBody
    );
  }

  getCsvFromGhgEmissionScopeWise(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.AI.endpoint}${URLS.AI.methods.GetCsvFromGhgEmissionScopeWise}`,
      requestBody
    );
  }

  flattenJson(obj: any, parentKey: string = '', result: any[] = []): any[] {
    for (let key in obj) {
      if (!obj.hasOwnProperty(key)) continue;

      const newKey = parentKey ? `${parentKey}.${key}` : key;
      const value = obj[key];

      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          const arrayKey = `${newKey}[${index}]`;
          if (typeof item === 'object' && item !== null) {
            this.flattenJson(item, arrayKey, result);
          } else {
            result.push({ key: arrayKey, value: item });
          }
        });
      } else if (typeof value === 'object' && value !== null) {
        this.flattenJson(value, newKey, result);
      } else {
        result.push({ key: newKey, value });
      }
    }

    return result;
  }

  convertDocumentUrlToBlob(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }

  getFileIconOrType(file: any, isType: boolean = false): string {
    let fileName = '';
    let fileIcon = '';
    let fileType = '';

    if (file instanceof File) {
      fileName = file.name?.toLowerCase();
    } else if (typeof file === 'string') {
      const parts = file.split(/[/\\]/);
      fileName = parts[parts.length - 1].toLowerCase();
    }

    if (fileName.endsWith('.pdf')) {
      fileIcon = '../../../../../assets/images/pdf_icon1.png';
      fileType = 'pdf';
    } else if (fileName.endsWith('.doc') || fileName.endsWith('.docx')) {
      fileIcon = '../../../../../assets/images/word1.png';
      fileType = 'doc';
    } else if (fileName.match(/\.(jpg|jpeg|png|gif)$/)) {
      fileIcon = '../../../../../assets/images/img_file_icon.svg';
      fileType = 'image';
    } else if (
      fileName.endsWith('.xls') ||
      fileName.endsWith('.xlsx') ||
      fileName.endsWith('.xlsm')
    ) {
      fileIcon = '../../../../../assets/images/excel_icon.png';
      fileType = 'xls';
    } else {
      fileIcon = '../../../../../assets/images/default_file_icon.png';
      fileType = 'image';
    }

    return isType ? fileType : fileIcon;
  }

  getCsvForMAReport(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.AI.endpoint}${URLS.AI.methods.GetCsvForMAReport}`,
      requestBody
    );
  }

  /**
   * checking module and subModuleName
   *
   * @param name
   * @returns true|false
   */
  isModuleSubmoduleActive(name: any) {
    let accessModules: any = this.getUserAccessModule() || [];

    return accessModules?.find(
      (ele: any) =>
        ele.moduleName == name ||
        ele?.getUserAccessSubModuleDetails?.find(
          (sub: any) => sub.subModuleName == name
        )
    )
      ? true
      : false;
  }

  /**
   * checking every module name in modules and submodules
   *
   * @param modules
   * @returns
   */
  isEveryModuleSubmoduleActive(modules: any) {
    let accessModules: any = this.getUserAccessModule() || [];

    return modules.every((module: string) =>
      accessModules.some(
        (ele: any) =>
          ele.moduleName.toLowerCase() == module.toLowerCase() ||
          ele?.getUserAccessSubModuleDetails?.some(
            (sub: any) =>
              sub.subModuleName.toLowerCase() == module.toLowerCase()
          )
      )
    );
  }

  /**
   * Returns true if any field in the row/formGroup has meaningful data
   */
  hasMeaningfulData(row: any): boolean {
    // -------- Plain Object --------
    if (typeof row === 'object' && !('controls' in row)) {
      const { id, ...rest } = row;

      // Case 1: API data (id exists & not zero)
      if (id != null && id !== 0) {
        return true;
      }

      // Case 2: Fresh data (id === 0)
      return Object.values(rest).some(value =>
        value == null
          ? false
          : typeof value === 'string'
            ? value.trim().length > 0
            : true
      );
    }

    // --------  FormGroup / FormControl --------
    if (row?.controls) {
      const idValue = row.controls['id']?.value;

      // Case 1: API data
      if (idValue != null && idValue !== 0) {
        return true;
      }

      // Case 2: Fresh data
      return Object.keys(row.controls)
        .filter(key => key !== 'id')
        .some(key => {
          const value = row.controls[key].value;
          if (value == null) return false;
          if (typeof value === 'string') return value.trim().length > 0;
          return true;
        });
    }

    return false;
  }

  getAiBasedQualitativeAssessment(requestData: any) {
    return this.http.post(
      `https://zkynaikgmznxoylronqd.supabase.co/functions/v1/brsr-qualitative-assessment`,
      requestData
    );
  }

  getAllTagsByTagTypeIds(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetAllTagsByTagTypeIds}`,
      requestBody
    );
  }

  addDropdownOrSubDropdownItem(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.AddDropdownOrSubDropdownItem}`,
      requestBody
    );
  }

  getEmissionStandardIdByLocation(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Master.endpoint}${URLS.Master.methods.GetEmissionStandardIdByLocation}`,
      requestBody
    );
  }

  convertToCSV(data: any) {
    return data
      .map((row: any) =>
        row
          .map((cell: any) => {
            if (cell === null || cell === undefined) return '';
            const str = cell.toString();
            return str.includes(',') || str.includes('"')
              ? `"${str.replace(/"/g, '""')}"`
              : str;
          })
          .join(',')
      )
      .join('\n');
  }

  getCsvFromGhgEmissionPeriodAndLocationWise(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.AI.endpoint}${URLS.AI.methods.GetCsvFromGhgEmissionPeriodAndLocationWise}`,
      requestBody
    );
  }

  getCSRDBase64ReportData(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.AI.endpoint}${URLS.AI.methods.GetAIReportDataWithLastAndSeconLastYearDataAsync}`,
      requestBody
    );
  }

  getAIBasedSessionIdForUploadedCsv(requestData: any) {
    return this.http.post(
      `https://zkynaikgmznxoylronqd.supabase.co/functions/v1/csv-upload`,
      requestData
    );
  }
}
